import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'lambda', 'Lambda', [["path",{"d":"M6 20l6.5 -9","key":"svg-0"}],["path",{"d":"M19 20c-6 0 -6 -16 -12 -16","key":"svg-1"}]]);